import React, { useState } from 'react';
import { useBookingData } from '../../hooks/useBookingData';

const GuestsStep = ({ onGuestsSelect, formState }) => {
    const { calculateDiscountBreakdown } = useBookingData();
    const [isGroupMode, setIsGroupMode] = useState(false);
    const [customCount, setCustomCount] = useState(12);

    const getBadgeForGuestCount = (count) => {
        if (!formState?.date || !formState?.time || !calculateDiscountBreakdown) return null;
        const breakdown = calculateDiscountBreakdown(formState.date, formState.time, count);
        if (!breakdown || breakdown.length === 0) return { label: 'Cheio', color: 'gray' };
        
        const finalPercent = breakdown[0].percent;
        if (finalPercent > 0) {
            const color = finalPercent >= 50 ? '#d97706' : '#2563eb';
            return { label: `-${finalPercent}%`, color: color };
        }
        return null;
    };

    const renderGuestButton = (count) => {
        const badge = getBadgeForGuestCount(count);
        const isFull = badge?.label === 'Cheio';

        return (
            <button 
                key={count} 
                type="button" 
                disabled={isFull}
                onClick={() => onGuestsSelect(count)} 
                style={{
                    position: 'relative',
                    height: '64px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '8px',
                    border: isFull ? '1px solid #e5e7eb' : '1px solid #9ca3af', // Borda mais visível
                    backgroundColor: isFull ? '#f3f4f6' : 'white',
                    color: isFull ? '#9ca3af' : '#111827', // PRETO NÍTIDO AQUI
                    cursor: isFull ? 'not-allowed' : 'pointer',
                    fontSize: '20px', // Aumentei um pouco o tamanho
                    fontWeight: 'bold', // Forçar negrito
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}
            >
                {count}
                {!isFull && badge && (
                    <div style={{
                        position: 'absolute', top: '-8px', right: '-8px', backgroundColor: badge.color,
                        color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '2px 6px',
                        borderRadius: '4px', zIndex: 20, border: '1px solid white', lineHeight: '1'
                    }}>
                        {badge.label}
                    </div>
                )}
            </button>
        );
    };

    return (
        <div className="animate-fade-in" style={{ paddingBottom: '20px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '24px' }}>
                Quantas pessoas?
            </h3>
            
            {!isGroupMode ? (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
                    {[...Array(10)].map((_, i) => renderGuestButton(i + 1))}
                    
                    <button 
                        type="button" 
                        onClick={() => setIsGroupMode(true)} 
                        style={{
                            gridColumn: 'span 2', height: '64px', borderRadius: '8px',
                            border: '1px solid #9ca3af', backgroundColor: '#f9fafb',
                            color: '#111827', // PRETO NÍTIDO AQUI TAMBÉM
                            fontWeight: 'bold', fontSize: '15px', cursor: 'pointer'
                        }}
                    >
                        11+ (Grupo)
                    </button>
                </div>
            ) : (
                <div style={{ 
                    padding: '24px', backgroundColor: '#fff7ed', borderRadius: '12px', 
                    border: '2px solid #ffedd5', textAlign: 'center' 
                }}>
                    <p style={{ marginBottom: '16px', fontSize: '16px', color: '#111827', fontWeight: 'bold' }}>
                        Indique o número exato de pessoas:
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
                        <button 
                            type="button"
                            onClick={() => setCustomCount(Math.max(11, customCount - 1))}
                            style={{ width: '45px', height: '45px', borderRadius: '50%', border: '2px solid #d97706', backgroundColor: 'white', fontSize: '24px', fontWeight: 'bold', cursor: 'pointer', color: '#111827' }}
                        >-</button>
                        
                        <span style={{ fontSize: '32px', fontWeight: 'bold', minWidth: '50px', color: '#111827' }}>{customCount}</span>
                        
                        <button 
                            type="button"
                            onClick={() => setCustomCount(customCount + 1)}
                            style={{ width: '45px', height: '45px', borderRadius: '50%', border: '2px solid #d97706', backgroundColor: 'white', fontSize: '24px', fontWeight: 'bold', cursor: 'pointer', color: '#111827' }}
                        >+</button>
                    </div>
                    
                    <div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
                        <button 
                            type="button"
                            onClick={() => setIsGroupMode(false)}
                            style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #d1d5db', backgroundColor: 'white', fontWeight: '600', cursor: 'pointer', color: '#4b5563' }}
                        >Voltar</button>
                        <button 
                            type="button"
                            onClick={() => onGuestsSelect(customCount, true)}
                            style={{ flex: 2, padding: '12px', borderRadius: '8px', border: 'none', backgroundColor: '#d97706', color: 'white', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }}
                        >Confirmar {customCount} Pessoas</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GuestsStep;